import { render, staticRenderFns } from "./addBtn.vue?vue&type=template&id=09262519&scoped=true"
import script from "./addBtn.vue?vue&type=script&lang=js"
export * from "./addBtn.vue?vue&type=script&lang=js"
import style0 from "./addBtn.vue?vue&type=style&index=0&id=09262519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09262519",
  null
  
)

export default component.exports